module.exports = "https://99designs-start-assets.imgix.net/js/e078a1436ae4c13d2925dab7ba84adff.svg";